// Copyright (c) 2016 Deere & Company

import PipCodeType, {getDefaultState} from '../state/pip-code-type';
import actions from '../../actions-list';

const updatePipCodeType = (state, action) =>
    PipCodeType.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_PIP_CODE_TYPE_SUCCESS]: updatePipCodeType
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-code/reducers/pip-code-type.js